var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
var SurveyQuestionBoolean = /** @class */ (function (_super) {
    __extends(SurveyQuestionBoolean, _super);
    function SurveyQuestionBoolean(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.handleOnLabelClick = _this.handleOnLabelClick.bind(_this);
        _this.handleOnSwitchClick = _this.handleOnSwitchClick.bind(_this);
        _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
        _this.checkRef = React.createRef();
        return _this;
    }
    SurveyQuestionBoolean.prototype.getStateElement = function () {
        return this.question;
    };
    Object.defineProperty(SurveyQuestionBoolean.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    /*
    private get allowClick(): boolean {
      return this.question.isIndeterminate && !this.isDisplayMode;
    }
    */
    SurveyQuestionBoolean.prototype.doCheck = function (value) {
        this.question.booleanValue = value;
    };
    SurveyQuestionBoolean.prototype.handleOnChange = function (event) {
        this.doCheck(event.target.checked);
    };
    SurveyQuestionBoolean.prototype.handleOnClick = function (event) {
        this.question.onLabelClick(event, true);
    };
    SurveyQuestionBoolean.prototype.handleOnSwitchClick = function (event) {
        this.question.onSwitchClickModel(event.nativeEvent);
    };
    SurveyQuestionBoolean.prototype.handleOnLabelClick = function (event, value) {
        this.question.onLabelClick(event, value);
    };
    SurveyQuestionBoolean.prototype.handleOnKeyDown = function (event) {
        this.question.onKeyDownCore(event);
    };
    SurveyQuestionBoolean.prototype.updateDomElement = function () {
        if (!this.question)
            return;
        var el = this.checkRef.current;
        if (el) {
            el.indeterminate = this.question.isIndeterminate;
        }
        this.setControl(el);
        _super.prototype.updateDomElement.call(this);
    };
    SurveyQuestionBoolean.prototype.renderElement = function () {
        var _this = this;
        var cssClasses = this.question.cssClasses;
        var itemClass = this.question.getItemCss();
        return (React.createElement("div", { className: cssClasses.root, onKeyDown: this.handleOnKeyDown },
            React.createElement("label", { className: itemClass },
                React.createElement("input", { ref: this.checkRef, type: "checkbox", name: this.question.name, value: this.question.booleanValue === null
                        ? ""
                        : this.question.booleanValue, id: this.question.inputId, className: cssClasses.control, disabled: this.question.isDisabledAttr, readOnly: this.question.isReadOnlyAttr, checked: this.question.booleanValue || false, onChange: this.handleOnChange, role: this.question.a11y_input_ariaRole, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-describedby": this.question.a11y_input_ariaDescribedBy, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage }),
                React.createElement("div", { className: cssClasses.sliderGhost, onClick: function (event) { return _this.handleOnLabelClick(event, _this.question.swapOrder); } },
                    React.createElement("span", { className: this.question.getLabelCss(this.question.swapOrder) }, this.renderLocString(this.question.locLabelLeft))),
                React.createElement("div", { className: cssClasses.switch, onClick: this.handleOnSwitchClick },
                    React.createElement("span", { className: cssClasses.slider }, this.question.isDeterminated && cssClasses.sliderText ?
                        React.createElement("span", { className: cssClasses.sliderText }, this.renderLocString(this.question.getCheckedLabel()))
                        : null)),
                React.createElement("div", { className: cssClasses.sliderGhost, onClick: function (event) { return _this.handleOnLabelClick(event, !_this.question.swapOrder); } },
                    React.createElement("span", { className: this.question.getLabelCss(!this.question.swapOrder) }, this.renderLocString(this.question.locLabelRight))))));
    };
    return SurveyQuestionBoolean;
}(SurveyQuestionElementBase));
export { SurveyQuestionBoolean };
ReactQuestionFactory.Instance.registerQuestion("boolean", function (props) {
    return React.createElement(SurveyQuestionBoolean, props);
});
